import React from "react";
import { PROVIDERS, HOME_ALIASES } from "./config/providersData";
import { HomePage } from "./pages/HomePage";
import { ProviderPage } from "./pages/ProviderPage";
import { NotFound } from "./pages/NotFound";
import {
  AProposPage,
  ContactPage,
  FAQPage,
  DisclaimerPage,
  CGUPage,
  ConfidentialitePage,
  CookiesPage,
} from "./pages/legal";

// Routage volontairement minimal (pas de react-router) : chaque lien interne est un <a href>
// classique qui recharge la page, pour que le script de suivi d'appels (public/js/suivi-appels.js)
// s'exécute sur chaque page. Ne pas remplacer par une navigation SPA.
const PAGES = {
  "/": HomePage,
  "/a-propos": AProposPage,
  "/contact": ContactPage,
  "/faq": FAQPage,
  "/avertissement": DisclaimerPage,
  "/cgu": CGUPage,
  "/confidentialite": ConfidentialitePage,
  "/cookies": CookiesPage,
};

function normalize(pathname) {
  let p = pathname || "/";
  try {
    p = decodeURIComponent(p);
  } catch {
    // chemin non décodable : on le garde tel quel
  }
  if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
  return p;
}

export default function App() {
  const path = normalize(window.location.pathname);
  const lower = path.toLowerCase();

  const Page = PAGES[lower];
  if (Page) return <Page />;

  // URL d'annonce fournisseur (insensible à la casse, ex. /comparer/Bouygues).
  const providerPath = Object.keys(PROVIDERS).find((k) => k.toLowerCase() === lower);
  if (providerPath) return <ProviderPage provider={PROVIDERS[providerPath]} path={providerPath} />;

  // Anciennes URL qui affichent l'accueil.
  if (HOME_ALIASES.some((a) => a.toLowerCase() === lower)) return <HomePage />;

  return <NotFound />;
}
